/* TopPanel.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React from 'react';
import { MODAL_HEADING_ID } from '../constants';
const topPanelStyles = xcss({
  flex: 0,
  paddingTop: 'space.200',
  paddingBottom: 'space.200',
  paddingLeft: 'space.300',
  paddingRight: 'space.300',
  borderBottomColor: 'color.border',
  borderBottomWidth: 'border.width',
  borderBottomStyle: 'solid'
});
const headingTextStyles = xcss({
  fontSize: '1.25rem',
  fontWeight: '600'
});
export const TopPanel = _ref => {
  let {
    onClose,
    enableSort
  } = _ref;
  return /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    xcss: topPanelStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: headingTextStyles,
    as: "h2",
    id: MODAL_HEADING_ID
  }, enableSort ? 'Sort & filter' : 'Filter'), /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: CrossIcon,
    label: "Close filters",
    onClick: onClose
  }));
};